import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=ba69b42a&scoped=true"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=ba69b42a&prod&lang=css"
import style1 from "./Detalhes.vue?vue&type=style&index=1&id=ba69b42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba69b42a",
  null
  
)

export default component.exports